// Generated by packages/assets/scripts/generate.ts. Do not edit; edit the sources and run pnpm generate.
import type { ThemeFile } from "../src/themes.ts";

export const THEMES = {
  "day": {
    "id": "day",
    "name": "Day",
    "status": "free",
    "appearance": "light",
    "paper": "#F2F0E8",
    "ink": "#000000",
    "accent": "#E0301E",
    "accents": [],
    "fog": {
      "base": 0.1,
      "clouds": 0.28,
      "shadow": 0.7
    }
  },
  "night": {
    "id": "night",
    "name": "Night",
    "status": "free",
    "appearance": "dark",
    "paper": "#2E2C28",
    "ink": "#ECE8DC",
    "shade": "#000000",
    "line": "#76736B",
    "accent": "#E0301E",
    "accents": [],
    "background": "#1D1C1B",
    "text": "#ECE8DC",
    "glow": 0,
    "fog": {
      "base": 0.06,
      "clouds": 0.18,
      "shadow": 0.16
    }
  },
} as const satisfies Record<string, ThemeFile>;

export type ThemeId = keyof typeof THEMES;

export const THEME_IDS = Object.keys(THEMES) as ThemeId[];
